import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Row,
  Col,
  Button,
  Input,
  Badge,
} from "reactstrap";
import { getGSTDetails } from "../../util/APIUtils";
import "../../views/Dashboard/Dashboard.css";
import { LoadingOverlay } from "../../util/Helpers";
import swal from "sweetalert";
import { Divider } from "antd";
import { ButtonStyles } from "../../constants/ButtonStyles";

const GstDetails = () => {
  const [block, setBlock] = useState(false);
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [salesDetails, setSalesDetails] = useState([]);
  const [totalGST, setTotalGST] = useState("");

  const [dateFilter, setDateFilter] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });

  useEffect(() => { }, []);

  const onChangeNotesMap = ({ target }) => {
    const { name, value } = target;
    setDateFilter((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };
  const updateMap = () => {
    if (Object.keys(dateFilter).length !== 2) {
      return false;
    }
    setBlock(true);
    getGSTDetails(dateFilter)
      .then((response) => {
        setPurchaseDetails(response.purchaseDetails);
        setSalesDetails(response.salesDetails);
        setTotalGST(response.totalGst);
        setBlock(false);
      })
      .catch((error) => {
        setBlock(false);
        swal({
          text: "Unexpected Error " + error,
        });
      });
  };
  const clearAll = () => {
    setDateFilter({
      frmDate: new Date().toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
    });
  };

  return (
    <div>
      {block && <LoadingOverlay />}
      <Card style={{
        borderRadius: "15px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
        border: "none",
        overflow: "hidden"
      }}>
        <CardHeader style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "20px 25px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: "none"
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <i className="fa fa-percent" style={{ fontSize: "24px", color: "#fff" }}></i>
            <strong style={{ fontSize: '1.2rem', color: "#fff" }}>GST Details</strong>
          </div>
        </CardHeader>
        <CardBody style={{ padding: "25px" }}>
          <Row className="mb-3" style={{ alignItems: "center" }}>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="frmDate"
                id="frmDate"
                onChange={onChangeNotesMap}
                value={dateFilter.frmDate || ""}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="toDate"
                id="toDate"
                onChange={onChangeNotesMap}
                value={dateFilter.toDate || ""}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Button style={{ ...ButtonStyles.primarySm, marginRight: "10px" }} onClick={updateMap}>
                <i className="fa fa-search" style={{ marginRight: "5px" }} />Go
              </Button>
              <Button style={ButtonStyles.secondarySm} onClick={clearAll}>
                <i className="fa fa-times" style={{ marginRight: "5px" }} />Cancel
              </Button>
            </Col>
            <Col sm="3" />
          </Row>
          <Row style={{ marginBottom: "25px" }}>
            <Col sm="4">
              <Card style={{
                background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Total GST</div>
                <div style={{ fontSize: "28px", fontWeight: "700" }}>{totalGST || "0"}</div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="6">
              <h5 style={{ color: "#667eea", fontWeight: "700", textAlign: "center", marginBottom: "15px" }}>Purchase Details</h5>
              <Table bordered style={{ borderRadius: "10px", overflow: "hidden" }}>
                <thead style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
                  <tr>
                    <th style={{ color: "#fff", border: "none" }}>Item</th>
                    <th style={{ color: "#fff", border: "none" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseDetails.map((item, index) => (
                    <TableRow key={index} label={item.key} value={item.value} />
                  ))}
                </tbody>
              </Table>
            </Col>
            <Col sm="6">
              <h5 style={{ color: "#667eea", fontWeight: "700", textAlign: "center", marginBottom: "15px" }}>Sales Details</h5>
              <Table bordered style={{ borderRadius: "10px", overflow: "hidden" }}>
                <thead style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
                  <tr>
                    <th style={{ color: "#fff", border: "none" }}>Item</th>
                    <th style={{ color: "#fff", border: "none" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {salesDetails.map((item, index) => (
                    <TableRow key={index} label={item.key} value={item.value} />
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

const TableRow = ({ label, value }) => (
  <tr>
    <td>{label}</td>
    <td>{value || ""}</td>
  </tr>
);

export default GstDetails;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/GstDetails.js